import GameManager from '../GameManager';
import UIManager, { UI, UIInstance } from './UiManager';

/**
 * Manages the UI for a JSX-type framework
 */
export default class JsxUIManager extends UIManager {
	/**
	 * ctor
	 * @param gameManager A reference to the Game Manager
	 */
	constructor(gameManager: GameManager) {
		super(gameManager)
	}

	/**
	 * Registers a single UI
	 * @param uiName The name of the UI to register
	 * @param uiData Data to append to the UI
	 * @param tag Optional: Use this to group UIs. Example: 'HUD'
	 * @returns true if it was successfully registered
	 */
	 public registerUI(uiName: string, uiData: JSXUIData, tag?: string): boolean {
		var result = super.registerUI(uiName, uiData, tag);
		return result;
	}

	/**
	 * Calls renderMethod in all UIs.
	 * @returns The html to render
	 */
	public render(): any {
		var result = [];
		for(var uiIndx = 0; uiIndx < this._uis.length; uiIndx++) {
			var ui = this._uis[uiIndx];

			for(var uiInstanceIndx = 0; uiInstanceIndx < ui.instances.length; uiInstanceIndx++) {
				var instance = ui.instances[uiInstanceIndx];
				var res = this._renderUiInstance(ui, instance);
				if(res) {
					result.push(res);
				}
			}
		}

		return result;
	}

	/**
	 * Renders a single instance (if it should be rendered)
	 * @param ui The instance of the UI
	 * @param instance The instance itself
	 * @returns The html to render for a single instance
	 */
	private _renderUiInstance(ui: UI, instance: UIInstance): any {
		return instance.parameters.isVisible && ui.uiData.renderMethod ?
			ui.uiData.renderMethod(instance)
			: null;
	}
}

export interface JSXUIData {
	/**
	 * Called for every instance of this UI when it needs to be rendered
	 */
	renderMethod: (uiInstance: any) => any;
}